var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestoreActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7713 11.6862C16.5476 9.57563 13.7155 11.5981 12.0007 13.3129C10.2859 11.5981 7.45386 9.57563 5.23007 11.6862C1.55697 15.1743 8.77 22.1166 12.0007 22.6489C15.2314 22.1166 22.4444 15.1743 18.7713 11.6862Z",
    fill: "#ddf2bf"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7713 11.6862C16.5476 9.57563 13.7155 11.5981 12.0007 13.3129C10.2859 11.5981 7.45386 9.57563 5.23007 11.6862C1.55697 15.1743 8.77 22.1166 12.0007 22.6489C15.2314 22.1166 22.4444 15.1743 18.7713 11.6862Z",
    stroke: "#112911",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79688 19.145L7.58737 18.3545L11.9999 13.3125L16.4124 18.3545L17.2029 19.145",
    stroke: "#112911",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0008 8.14279C13.8944 8.14279 15.4294 6.60776 15.4294 4.71422C15.4294 2.82067 13.8944 1.28564 12.0008 1.28564C10.1073 1.28564 8.57227 2.82067 8.57227 4.71422C8.57227 6.60776 10.1073 8.14279 12.0008 8.14279Z",
    fill: "#ddf2bf"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0008 8.14279C13.8944 8.14279 15.4294 6.60776 15.4294 4.71422C15.4294 2.82067 13.8944 1.28564 12.0008 1.28564C10.1073 1.28564 8.57227 2.82067 8.57227 4.71422C8.57227 6.60776 10.1073 8.14279 12.0008 8.14279Z",
    stroke: "#112911",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestoreActive);
export default __webpack_public_path__ + "static/media/restoreActive.eaf3cd015df09a9882d37d0f37e68ff7.svg";
export { ForwardRef as ReactComponent };